"use strict";
exports.__esModule = true;
exports.useEdularModulesContext = exports.EdularModulesContext = void 0;
var react_1 = require("react");
exports.EdularModulesContext = (0, react_1.createContext)();
function useEdularModulesContext() {
    var ctx = (0, react_1.useContext)(exports.EdularModulesContext);
    if (!ctx) {
        throw new Error('You have to wrap your component inside EdularModulesProvider');
    }
    return ctx;
}
exports.useEdularModulesContext = useEdularModulesContext;
